import React from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";

type ModalProps = {
  variant: "error" | "success" | "none";
  setOpenOrClose: (a: boolean) => void;
  children: JSX.Element | JSX.Element[];
  width: string;
};
type StyledProps = {
  width: string;
};

const Modal = ({ setOpenOrClose, children, variant, width }: ModalProps) => {
  return (
    <>
      <ModalBackground onClick={() => setOpenOrClose(false)}></ModalBackground>
      <ModalContainer width={width}>
        <ModalImageContainer>
          {variant === "error" && (
            <ModalImage
              src={require("../assets/images/modal-failure.png")}
              alt="failure"
            />
          )}
          {variant === "success" && (
            <ModalImage
              src={require("../assets/images/modal-success.png")}
              alt="success"
            />
          )}
        </ModalImageContainer>
        {children}
      </ModalContainer>
    </>
  );
};

export default Modal;

const ModalBackground = styled.div`
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  background: ${Colors.emperorApprox};
  opacity: 0.5;
  position: fixed;
  cursor: pointer;
`;
const ModalContainer = styled.div<StyledProps>`
  width: ${(props) => props.width};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  border-radius: 2rem;
  background-color: ${Colors.white};
`;
const ModalImageContainer = styled.div`
  display: flex;
  justify-content: center;
  transform: translateY(-2.5rem);
  height: 0rem;
`;
const ModalImage = styled.img`
  height: 5.5rem;
  width: 5.5rem;
`;
